const PREFIX = 'FACILITY_LOCATOR_';

export const GET_FACILITIES_FOR_MAP = `${PREFIX}GET_FACILITIES_FOR_MAP`;
export const SET_FACILITIES_FOR_MAP = `${PREFIX}SET_FACILITIES_FOR_MAP`;
